export const keycode = {
  TAB: 9,
  DELETE: 46,
  ENTER: 13,
}
